/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Twowaysvalve2Inputs */



/**
* | output |
* | --- |
* | "Two-way valve" |
*
* @param {Br_History_Key_Twowaysvalve2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_twowaysvalve2 = /** @type {((inputs?: Br_History_Key_Twowaysvalve2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Twowaysvalve2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Two-way valve")
	return /** @type {LocalizedString} */ ("Vanne deux voies")
});
export { br_history_key_twowaysvalve2 as "br_history_key_twoWaysValve" }